import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Tenorite',
    fontSize: 16,
  },
  palette: {
    primary: {
      main: '#f16253',
    },
    secondary: {
      main: '#ff4081',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          lineHeight: '1.25',
          textTransform: 'none',
          padding: "5px 16px",
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          lineHeight: '1.25',
          fontWeight: 500,
          padding: 6,
          borderColor: "#fbc4bf",
          color: "#9ca3af",
          textTransform: 'capitalize', // Ensures startCase-like appearance
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '--DataGrid-t-color-background-base': '#ffffff',
          '--DataGrid-t-header-background-base': '#f16253',
          '--DataGrid-t-color-foreground-base': '#ffffff',
        },
        footerContainer: {
          overflow: 'hidden',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '10px 14px',      
          height: '52px',       
          boxSizing: 'border-box',
        },
      },
    },
  },
});

export default theme;
